import type { PublicRoute } from "../../../routes/registry";
import ProductsPage from "./ProductsPage";

/** BR-WEB-004 — the legacy products page title and meta description (baseline § 3, typos fixed). */
const route: PublicRoute = {
  path: "/products",
  element: <ProductsPage />,
  title: "Toowoomba Outdoor Living Products including Patios, Decks, Carports and Vergolas | Greatway Patios",
  description:
    "Check out our gallery of products to see our outdoor patio and outdoor room designs. With Toowoomba's only outdoor display centre you're sure to find the perfect solution for your home.",
};

export default route;
